import React, { Component } from 'react';
import {
  GeckoModal,
  GeckoField,
  GECKO_CONSTS,
  GeckoModalService,
  GeckoToastService,
} from 'ui';
import AgentSelect from 'components/AgentSelect';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';

class DeleteAgentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      replacement_id: null,
    };
  }

  replacementField = {
    key: 'replacement_id',
    label: 'Re-assign Contacts and Conversations to',
    description:
      'Any Conversations assigned directly to this Agent or Contacts owned by this Agent will be transfered to the selected Agent',
    type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
    component: <AgentSelect multi={false} ignore={[this.props.agent_id]} />,
  };

  deleteAgent() {
    GeckoRequest.post('/agent/delete', {
      agent_id: this.props.agent_id,
      replacement_id: this.state.replacement_id,
    })
      .then(() => {
        new GeckoToastService().success('Agent deleted');
        new GeckoModalService().close();
      })
      .catch(renderError);
  }

  footerBtns = [
    {
      name: 'Delete',
      primary: true,
      preset: GECKO_CONSTS.BTN_PRESET_REMOVE,
      handler: this.deleteAgent.bind(this),
    },
    {
      name: 'Cancel',
      secondary: true,
      handler: () => new GeckoModalService().close(),
    },
  ];

  fieldHandler(key, val) {
    this.setState({ [key]: val });
  }

  render() {
    return (
      <GeckoModal
        name="Are you sure you want to delete this Agent?"
        btns={this.footerBtns}
      >
        <GeckoField
          field={this.replacementField}
          values={this.state}
          handler={this.fieldHandler.bind(this)}
        />
      </GeckoModal>
    );
  }
}

export default DeleteAgentModal;
